var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule"},[(_vm.isBusy)?_c('div',{staticClass:"loading-lg mx-auto loading-horizontal-center"}):_c('match-day-list',{attrs:{"matchDays":_vm.matchDays}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }